
import CartMain from './components/CartMain.vue';
import StepDelivery from './components/StepDelivery.vue';
import cartMixin from '@/mixins/cartMixin.js';
import CartEmptyError from '@/pages/cart/components/CartEmptyError.vue';
import { getProductPrice, getVariantSelected } from '@/utils/product.js';

export default {
  layout: 'tunnel',
  name: 'deliveryCartPage',
  mixins: [cartMixin],
  // middleware: ["Tunnel", "mdAddress"],
  data() {
    return {
      valide: false,
      loadedCart: false,
      hasProduct: false,
    };
  },
  computed: {
    guestUser() {
      return this.$store.state.user.guest.guestUser;
    },

    isLogin() {
      return this.$auth.loggedIn || this.guestUser;
    },
  },
  methods: {
    beginCheckoutGtm() {
      this.$gtm.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: this.$localisation.appCurrency.CurrencyIsoCode,
          value: this.cart?.Total?.Product?.TaxIncl,
          items: this.cart.Products?.map((product) => ({
            item_id: product.IdProduct,
            quantity: product.Quantity,
            price: getProductPrice(product),
            item_name: product.Description.Title,
            item_brand: product?.Brand?.Name || 'Jean Marc Philippe',
            item_variant: getVariantSelected(product),
          })),
        },
      });
    },
  },
  created() {
    this.loadedCart = false;
    this.cartService.fetchCart({
      onSuccess: () => {
        const listItemLocal = this.cart?.Total?.Product?.Quantity;
        if (listItemLocal !== 0) {
          this.hasProduct = true;
        }
        this.loadedCart = true;

        this.beginCheckoutGtm();
      },
      onError: () => {
        this.loadedCart = true;
      },
    });
  },
  components: {
    CartMain,
    StepDelivery,
    CartEmptyError,
  },
  //If Delivery Tabs is not in StepDelivery Reload
  watch: {
    $route(to, from) {
      const hasDeliveryTabs = this.$refs.stepDelivery.$refs.deliveryTabs;
      if (!hasDeliveryTabs) {
        window.location.reload();
      }
    },
  },
  mounted() {},
};
